import { sanitize } from "dompurify";

const HTMLSanitize = {
  install(Vue) {
    Vue.directive("safe-html", {
      inserted: function(el, binding) {
        el.innerHTML = sanitize(binding.value);
      },
      update: function(el, binding) {
        el.innerHTML = sanitize(binding.value);
      }
    });
  }
};

export default HTMLSanitize;
